import { render, staticRenderFns } from "./SFooter.vue?vue&type=template&id=c673fa1a&"
import script from "./SFooter.vue?vue&type=script&lang=js&"
export * from "./SFooter.vue?vue&type=script&lang=js&"
import style0 from "./SFooter.vue?vue&type=style&index=0&id=c673fa1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports